import { styled } from "styled-components";

const InputDetails = styled.div<{$suffix?: boolean, $fullWidth?: boolean}>`
    width: ${props => props.$fullWidth === true ? "100%" : undefined};
    position: relative;

    .input{
        width: 100%;
        
        padding: 10px 20px;
        border: none;

        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        outline: none;

        display: flex;
        align-items: center;
        gap: 10px;

        input{
            border: none;
            width: 100%;
            outline: none;
        }
    }

    input[type="checkbox"]{
        padding: 0;
        width: 18px;
        height: 18px;

        border: none;
        outline: none;
    }

    textarea{
        width: 100%;
        
        padding: 10px 20px;
        border: none;

        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        outline: none;
        resize: none;
    }

    .input-password{
        display: flex;
        align-items: center;
        
        width: 100%;

        padding: 10px 20px;

        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-radius: 6px;

        gap: 10px;

        input{
            width: 100%;
            
            outline: none;
            border: none;
        }
    }

    .icon{
        color: #8e8e8e;

        cursor: pointer;
    }

    .suffix{
        color: #8e8e8e;
    }
`

export default InputDetails;